export const ICON_COLOR = [
  "inherit",
  "accent",
  "primary",
  "success",
  "warning",
  "danger",
  "subdued",
  "neutral",
  "empty"
] as const;

export const ICON_SIZE = ["s", "m", "l", "xl", "xxl", "xxxl"] as const;

export const ICON_TYPE = ["default", "enclosed", "token"] as const;
